<template>
    <div class="container">
        <content-header title="Программы годового обслуживания"/>
        <img class="float-right" src="../../assets/images/staticPages/pr_gspt1-e1500450055822-291x300.png" height="300"
             width="291"/>
        <div class="box"><p>Для того, чтобы Вам и Вашим близким было спокойнее, мы разработали программы годового
            медицинского
            обслуживания. В течение всего периода прикрепления Вы будете чувствовать себя в комфорте и под надежной
            защитой наших врачей!</p>
            <p>Получить расчет стоимости, задать вопросы по оформлению договора, запланировать бесплатную консультацию
                врача
                перед заключением договора Вы можете по телефону:</p>
            <p><strong>тел. +7(495)620-81-29</strong></p></div>


        <div class="table-state" :class="{'open': showTable === 1}" @click="selectTable(1)">
            <h3>Или оставив заявку на нашем сайте:</h3>
            <div class="plus" v-if="showTable !== 1">
                <img class="plus"
                     src="../../assets/images/accordion_plus.png"
                     alt="">
            </div>
            <div class="minus" v-if="showTable === 1">
                <img src="../../assets/images/accordion_minus.png" alt="">
            </div>
        </div>
        <transition name="fade">
            <div v-if="showTable === 1">
                <static-page-contact-form></static-page-contact-form>
            </div>
        </transition>

        <div class="inv-divider"></div>
        <div class="divider"></div>
        <h3>Годовые медицинские программы</h3>

        <div class="department-tabs">
            <div class="tab" :class="{'tab--active': tab === '1'}" @click="tab = '1'">
                «ОПТИМА»
            </div>
            <div class="tab" :class="{'tab--active': tab === '2'}" @click="tab = '2'">
                «СТАНДАРТ»
            </div>
            <div class="tab" :class="{'tab--active': tab === '3'}" @click="tab ='3'">
                «VIP»
            </div>
        </div>
        <div class="department-price" v-if="tab === '1'">
            <table>
                <thead>
                <tr>
                    <th style="min-width: 4.1049%; width: 75px;">Код программы</th>
                    <th style="min-width: 7.0696%; width: 97px;">Наименование программы</th>
                    <th style="min-width: 63.854%; width: 392px;">Описание</th>
                    <th style="min-width: 8.3238%; width: 70px;">Стоимость для Пациентов от 18 до 59 лет</th>
                    <th style="min-width: 8.3238%; width: 70px;">Стоимость для Пациентов от 60 до 69 лет Кв1=1,5</th>
                    <th style="min-width: 8.3238%; width: 70px;">Стоимость для Пациентов старше 70 лет Кв2=2</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>87336</td>
                    <td>«ОПТИМА «АСВ»</td>
                    <td style="text-align: left">Амбулаторно-поликлиническое обслуживание со стоматологией и вызовом
                        врача на дом
                    </td>
                    <td>56 000 Руб.</td>
                    <td>84 000 Руб.</td>
                    <td>112 000 Руб.</td>
                </tr>
                <tr>
                    <td>87337</td>
                    <td>«ОПТИМА «АС»</td>
                    <td style="text-align: left">Амбулаторно-поликлиническое обслуживание со стоматологией, без вызова
                        врача
                    </td>
                    <td>53 200 Руб.</td>
                    <td>79 800 Руб.</td>
                    <td>106 400 Руб.</td>
                </tr>
                <tr>
                    <td>87303</td>
                    <td>«ОПТИМА «АВ»</td>
                    <td style="text-align: left">Амбулаторно-поликлиническое обслуживание с вызовом врача на дом, без
                        стоматологии
                    </td>
                    <td>50 400 Руб.</td>
                    <td>75 600 Руб.</td>
                    <td>100 800 Руб.</td>
                </tr>
                <tr>
                    <td>87304</td>
                    <td>«ОПТИМА «А»</td>
                    <td style="text-align: left">Амбулаторно-поликлиническое обслуживание без стоматологии, без вызова
                        врача на дом
                    </td>
                    <td>44 800 Руб.</td>
                    <td>67 200 Руб.</td>
                    <td>89 600 Руб.</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="department-price" v-if="tab === '2'">
            <table>
                <thead>
                <tr>
                    <th style="min-width: 4.1049%; width: 75px;">Код программы</th>
                    <th style="min-width: 7.0696%; width: 97px;">Наименование программы</th>
                    <th style="min-width: 63.854%; width: 392px;">Описание</th>
                    <th style="min-width: 8.3238%; width: 70px;">Стоимость для Пациентов от 18 до 59 лет</th>
                    <th style="min-width: 8.3238%; width: 70px;">Стоимость для Пациентов от 60 до 69 лет Кв1=1,5</th>
                    <th style="min-width: 8.3238%; width: 70px;">Стоимость для Пациентов старше 70 лет Кв2=2</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>87175</td>
                    <td>«СТАНДАРТ «АСВ»</td>
                    <td style="text-align: left">Амбулаторно-поликлиническое обслуживание со стоматологией и вызовом
                        врача на дом
                    </td>
                    <td>70 000 Руб.</td>
                    <td>105 000 Руб.</td>
                    <td>140 000 Руб.</td>
                </tr>
                <tr>
                    <td>87178</td>
                    <td>«СТАНДАРТ «АС»</td>
                    <td style="text-align: left">Амбулаторно-поликлиническое обслуживание со стоматологией, без вызова
                        врача
                    </td>
                    <td>66 500 Руб.</td>
                    <td>99 750 Руб.</td>
                    <td>133 000 Руб.</td>
                </tr>
                <tr>
                    <td>87154</td>
                    <td>«СТАНДАРТ «АВ»</td>
                    <td style="text-align: left">Амбулаторно-поликлиническое обслуживание, с вызовом врача на дом, без
                        стоматологии
                    </td>
                    <td>63 000 Руб.</td>
                    <td>94 500 Руб.</td>
                    <td>126 000 Руб.</td>
                </tr>
                <tr>
                    <td>87155</td>
                    <td>«СТАНДАРТ «А»</td>
                    <td style="text-align: left">Амбулаторно-поликлиническое обслуживание без стоматологии, без вызова
                        врача на дом
                    </td>
                    <td>56 000 Руб.</td>
                    <td>84 000 Руб.</td>
                    <td>112 000 Руб.</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="department-price" v-if="tab === '3'">
            <table>
                <thead>
                <tr>
                    <th style="min-width: 4.1049%; width: 75px;">Код программы</th>
                    <th style="min-width: 7.0696%; width: 97px;">Наименование программы</th>
                    <th style="min-width: 63.854%; width: 392px;">Описание</th>
                    <th style="min-width: 8.3238%; width: 70px;">Стоимость для Пациентов от 18 до 59 лет</th>
                    <th style="min-width: 8.3238%; width: 70px;">Стоимость для Пациентов от 60 до 69 лет Кв1=1,5</th>
                    <th style="min-width: 8.3238%; width: 70px;">Стоимость для Пациентов старше 70 лет Кв2=2</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>87334</td>
                    <td>«VIP «АСВ»</td>
                    <td style="text-align: left">Амбулаторно-поликлиническое обслуживание со стоматологией и вызовом
                        врача на дом- VIP
                    </td>
                    <td>120 000 Руб.</td>
                    <td>180 000 Руб.</td>
                    <td>240 000 Руб.</td>
                </tr>
                <tr>
                    <td>87335</td>
                    <td>«VIP «А»</td>
                    <td style="text-align: left">Амбулаторно-поликлиническое обслуживание без стоматологии, без вызова
                        врача - VIP
                    </td>
                    <td>87 000 Руб.</td>
                    <td>130 500 Руб.</td>
                    <td>174 000 Руб.</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="inv-divider"></div>

        <div class="arial-text">
            <p><strong>*Примечание:</strong></p>
            <p>— В таблице указана базовая годовая стоимость программы в рублях.<br>
                — Предусмотрена скидка в размере 10% за повторное или семейное (от 2-х человек) — прикрепление.<br>
                — При расчете стоимости программ для пациента от 60 до 69 лет базовая стоимость умножается на 1,5.<br>
                — При расчете стоимости программ для пациента старше 70 лет базовая стоимость умножается на 2.</p>
            <p>Амбулаторно-поликлиническое обслуживание проводится на базе — <strong>ФГБУ «Поликлиника №5»</strong></p>
            <p><strong>По адресу</strong>: г. Москва, ул. Плющиха, д.14( м. Смоленская, м.Киевская)</p>
            <p><strong>Часы приема</strong>: ПН-ПТ — с 8-00 до 20-00(с 07:00-21:00 по предварительной записи); СБ. — с
                9-00
                до 17-00 (летний режим до 15-00)</p>
            <p><strong>Вызов врача на дом</strong>: ПН-ПТ — с 8-00 до 13-00,по телефону+7(499) 248-07-60</p>
            <p><strong>Телефоны для записи на прием</strong>: регистратура ДМС +7(495) 620-81-05 (многоканальный);
                регистратура стоматологии+7(499) 248-31-06</p>
            <p><em>Медицинские услуги, подлежащие оплате Заказчиком при обращении Пациента в Поликлинику,
                предусмотренную
                Договором, за получением медицинских услуг в объёме Программы при остром заболевании, обострении
                хронического заболевания, травме, отравлении, в течение действия Договора:</em></p>
        </div>

        <div class="inv-divider"></div>

        <div class="flex center" v-if="tab === '1'">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="45"
                 width="45"/>
            <a href="/static/files/staticContent/Программа_Оптима_с_01.01.2021.pdf"
               target="_blank"
               class="link left-100px"><span>ПРОГРАММЫ МЕДИЦИНСКОГО ОБСЛУЖИВАНИЯ «ОПТИМА»</span></a>
        </div>
        <div class="flex center" v-if="tab === '2'">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="45"
                 width="45"/>
            <a href="/static/files/staticContent/Программа_Стандарт_с_01.01.2021.pdf"
               target="_blank"
               class="link left-100px"><span>ПРОГРАММЫ МЕДИЦИНСКОГО ОБСЛУЖИВАНИЯ «СТАНДАРТ»</span></a>
        </div>
        <div class="flex center" v-if="tab === '3'">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="45"
                 width="45"/>
            <a href="/static/files/staticContent/Программа_ВИП_с_01.01.2021.pdf"
               target="_blank"
               class="link left-100px"><span>ПРОГРАММЫ МЕДИЦИНСКОГО ОБСЛУЖИВАНИЯ «VIP»</span></a>
        </div>

        <div class="divider"></div>
        <h3>Доверьте заботу о Вашем здоровье профессионалам!</h3>
        <div class="inv-divider"></div>


        <div class="table-state" :class="{'open': showTable === 2}" @click="selectTable(2)">
            <h3>Наши преимущества:</h3>
            <div class="plus" v-if="showTable !== 2">
                <img class="plus"
                     src="../../assets/images/accordion_plus.png"
                     alt="">
            </div>
            <div class="minus" v-if="showTable === 2">
                <img src="../../assets/images/accordion_minus.png" alt="">
            </div>
        </div>

        <transition name="fade">
            <div v-if="showTable === 2">
                <p style="text-align: left;">• <strong>Поликлиника №5 на Плющихе</strong> – это многопрофильная клиника
                    с широким спектром специалистов, в том числе редких врачебных специальностей.<br>
                    • <strong>Высокая квалификация врачей</strong>. 69 % составляют специалисты высшей квалификационной
                    категории.<br>
                    • <strong>Наша репутация</strong> основана на 30 — летнем опыте ответственной работы<br>
                    • <strong>Мы удобно расположены</strong> в центре г.Москвы, в шаговой доступности от метро
                    Смоленская, Киевская<br>
                    • <strong>Мы используем</strong> <strong>новейшее</strong> диагностическое, лечебное оборудование, у
                    нас собственная лаборатория<br>
                    • <strong>У нас нет очередей</strong> – Пациенты, обслуживающиеся по годовым программам Поликлиники,
                    программам ДМС, корпоративные Клиенты и частные лица получают медицинские услуги в специально
                    созданном Консультативно-Диагностическом Отделении</p>
                <p style="text-align: left;"><em><strong>Для коллективов — лояльная система скидок!</strong></em></p>
            </div>
        </transition>
        <div class="inv-divider"></div>


        <div class="table-state" :class="{'open': showTable === 3}" @click="selectTable(3)">
            <h3>Подробная информация о врачах поликлиники</h3>
            <div class="plus" v-if="showTable !== 3">
                <img class="plus"
                     src="../../assets/images/accordion_plus.png"
                     alt="">
            </div>
            <div class="minus" v-if="showTable === 3">
                <img src="../../assets/images/accordion_minus.png" alt="">
            </div>
        </div>
        <transition name="fade">
            <div v-if="showTable === 3">
                <p><a href="http://5-clinic.com/ourdoctors/"><strong>Перейдите по ссылке</strong></a></p>
            </div>
        </transition>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";
import ServiceAndPricesMixin from "../../mixins/ServiceAndPricesMixin";
import pricesTable from "@/components/pricesTable";
import StaticPageContactForm from "@/components/StaticPageContactForm";

export default {
    mixins: [ServiceAndPricesMixin],
    components: {
        ContentHeader,
        pricesTable,
        StaticPageContactForm
    },
    data() {
        return {
            showTable: false,
            tab: '1',
        }
    },
    methods: {
        selectTable(id) {
            this.showTable = this.showTable === id ? null : id
        }
    }
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #006688;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    max-width: 480px;
    width: 100%;
    margin: 30px 0 70px 0;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
    margin-left: 15px;
}

.link > span {
    border-bottom: 1px dotted #006688;
}

.left-30px {
    margin-left: 30px;
}

.table-state {
    color: #666;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    position: sticky;

    &.open {
        padding: 10px 12px;
        background: #006688;
        color: white;
        margin-bottom: 20px;
    }

    h3 {
        font-size: 18px;
        font-weight: normal;
    }

    h3:hover {
        color: #3156A3;
    }

    &.open h3:hover {
        color: white;
    }

    @media screen and (max-width: 510px) {
        font-size: 11px;
    }
    @media screen and (max-width: 768px) {
        top: 0;
    }
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .4s, max-height .6s;
    max-height: 1000px;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
    max-height: 0;
}

.float-right {
    float: right;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.arial-text p {
    margin-top: -1.5em;
    margin-bottom: -1.5em;
    text-align: justify;
    font-size: small;
}

.department-tabs {
    font-size: 14px;
    display: flex;
    margin: 20px 0;

    .tab {
        color: #666;
        margin-right: 15px;
        cursor: pointer;

        &--active, &:hover {
            color: #000;
            border-bottom: 1px solid #00b6cc;
        }
    }
}

table {
    border-collapse: collapse;
}

thead th {
    color: rgb(255, 255, 255);
    background-color: rgb(0, 102, 136);
    text-align: center;
    padding: 0 18px;
    border-bottom: 1px solid #111;
    font-weight: bold;
}

tbody {
    background: white;
    border: 1px solid lightgray;
    box-sizing: border-box;
}

tbody td {
    text-align: center;
    padding: 8px 10px;
    border: 1px solid lightgray;
    box-sizing: border-box;
}

tbody tr:last-child td {
    border-bottom: 3px solid black;
}

.department-price {
    overflow: auto;
}

.department-price {

}
</style>
